import {View} from 'react-native-web';
import { Body, SubTitle, Title } from '../../../element/Text';



export default function Description({item}){
    return(
        <View style={{width:'100%', height:'100%', }}>  
         <Title value={item.title} color1={'#F9BA49'}/>
         <View style={{width:'90%', height:'90%' , backgroundColor:'#252525', alignSelf:'center',shadowColor:'#000000', shadowOpacity:1, shadowRadius:10, shadowOffset:{width:5, height:5}, borderRadius:16, marginTop:15, borderColor:'#F9BA49', borderWidth:1.8}} >
         <SubTitle value={item.subtitle} color1={'#F9BA49'}/>
         <Body value={item.body} color1={'#F9BA49'}/>
         </View>
         </View>

    )}